<script setup>
import { defineProps } from 'vue';

defineProps({
    isPrevDisabled: {
        type: Boolean,
        required: true
    },
    isNextDisabled: {
        type: Boolean,
        required: true
    },
    onPrev: {
        type: Function,
        required: true
    },
    onNext: {
        type: Function,
        required: true
    }
});
</script>
<template>
    <div class="pagination-buttons">
        <button
            class="pagination-btn d-flex flex-row justify-center align-center"
            :class="{ disabled: isPrevDisabled }"
            :disabled="isPrevDisabled"
            @click="onPrev"
        >
            <i class="material-symbols-outlined text-lg">chevron_left</i>
        </button>

        <button
            class="pagination-btn d-flex flex-row justify-center align-center"
            :class="{ disabled: isNextDisabled }"
            :disabled="isNextDisabled"
            @click="onNext"
        >
            <i class="material-symbols-outlined text-lg">chevron_right</i>
        </button>
    </div>
</template>

<style scoped>
.pagination-buttons {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}

.pagination-btn {
    background: none;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    cursor: pointer;
    margin: 0 0.5rem;
    border-radius: 4px;
}

.pagination-btn:hover:not(:disabled) {
    background-color: #f0f0f0;
}

.pagination-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
